import api from '../api.js';
import db from '../../versa/db.js';

export default function()
{
	return {
		_userTouched: false,

		init()
		{
			const el = document.querySelector(this.selector);
			el?.addEventListener('input', () => {
				this._userTouched = true;
			});
			el?.addEventListener('change', () => {
				this._userTouched = true;
			});
		},

		resetAuto()
		{
			this._userTouched = false;
		},

		async syncFromCustomer(customer_id)
		{
			try {
				await this.setFromCustomer(customer_id);
			} catch {
				// Campo opcional: falha de cache/API não deve bloquear edição manual do pedido.
			}
		},

		async actions(ev, publisher, value)
		{
			if (publisher.selector === '#customer_id')
			{
				this._userTouched = false;
				await this.setFromCustomer(value);
			}
		},

		async setFromCustomer(customer_id)
		{
			if (this._userTouched)
				return;
			const company_id = this.locate?.('company_id')?.getValue?.();
			if (!company_id || !customer_id)
				return;
			let customer = await db.get('customers', [company_id, Number(customer_id)]).catch(() => null);
			if (!customer || customer.payment_method === undefined)
			{
				customer = await api.call(api.select_customer, company_id, Number(customer_id));
				if (customer)
					await db.set('customers', [customer]).catch(() => {});
			}
			if (!customer)
				return;
			const payment_method = customer.payment_method || '';
			if (payment_method)
			{
				this.setValue?.(payment_method);
				this.refresh?.();
			}
		}
	};
}
